import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cc-lg-label-input',
  templateUrl: './label-input.component.html',
  styleUrls: ['./label-input.component.scss']
})
export class LabelInputComponent implements OnInit {
  private static ERROR_KEYS = {
    maxlength: 'ERRORS.TOO_LONG'
  };
  private static DEFAULT_ERROR = 'ERRORS.INVALID_VALUE';

  @Input() label: string;
  @Input() control: FormControl;
  @Input() icon: String;
  @Input() textarea: boolean;

  constructor() {}

  ngOnInit() {}

  getErrorKey(): string {
    if (!this.control.invalid) {
      return '';
    }
    const errors = this.control.errors;
    return (
      Object.keys(errors)
        .map(error => LabelInputComponent.ERROR_KEYS[error])
        .find(x => !!x) || LabelInputComponent.DEFAULT_ERROR
    );
  }
}
